var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('main',{staticClass:"l-content"},[_c('MainCarousel',{attrs:{"carousel":_vm.pageData.top_banner}}),(_vm.pageData)?_c('Description',{attrs:{"col1":_vm.pageData.description1,"col2":_vm.pageData.description2}}):_vm._e(),_c('JoinUs'),_c('GridSection'),_c('MenuCarousel')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }